/* istanbul ignore file */
import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-data-placeholder',
  templateUrl: './dashboard-data-placeholder.component.html',
  styleUrls: ['./dashboard-data-placeholder.component.scss']
})
export class DashboardDataPlaceholderComponent { }
